import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaReact, 
  FaNodeJs, 
  FaWordpress, 
  FaHtml5, 
  FaCss3Alt, 
  FaJs, 
  FaDatabase, 
  FaGithub 
} from 'react-icons/fa';
import AnimatedSection from '../common/AnimatedSection';

const TechStackSection = () => {
  const technologies = [
    { icon: <FaReact />, name: 'React', color: '#61DAFB' },
    { icon: <FaNodeJs />, name: 'Node.js', color: '#339933' },
    { icon: <FaWordpress />, name: 'WordPress', color: '#21759B' },
    { icon: <FaHtml5 />, name: 'HTML5', color: '#E34F26' },
    { icon: <FaCss3Alt />, name: 'CSS3', color: '#1572B6' },
    { icon: <FaJs />, name: 'JavaScript', color: '#F7DF1E' },
    { icon: <FaDatabase />, name: 'MongoDB', color: '#47A248' },
    { icon: <FaGithub />, name: 'GitHub', color: '#181717' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <AnimatedSection className="text-center mb-16" direction="up">
          <h2 className="section-title">Notre Stack Technologique</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nous utilisons les technologies les plus modernes et performantes pour développer votre projet web.
          </p>
        </AnimatedSection>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
          {technologies.map((tech, index) => (
            <AnimatedSection 
              key={index}
              className="text-center"
              direction="up"
              delay={index * 0.1}
            >
              <motion.div 
                className="flex flex-col items-center"
                whileHover={{ y: -10 }}
                transition={{ type: 'spring', stiffness: 400 }}
              >
                <div 
                  className="text-5xl md:text-6xl mb-3"
                  style={{ color: tech.color }}
                >
                  {tech.icon}
                </div>
                <span className="text-dark-gray font-medium">{tech.name}</span>
              </motion.div>
            </AnimatedSection>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TechStackSection;